import { Component } from '@angular/core';

@Component({
    selector: 'doctor',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class DoctorComponent {}
